import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ResponseMSGraph} from "../graphInterface/GraphInterfaces";
import {ActivatedRouteSnapshot, Router, UrlTree} from "@angular/router";
import {MsalService} from "@azure/msal-angular";
import {Observable} from "rxjs";
import { modulosActivos } from "../hub-externo/Modulo-Externo";
import { modulosActivos as modulosHub } from "../hub/Modulo";
import {Injectable} from "@angular/core";
@Injectable()
export class ModulosFunctions{
  constructor(private http: HttpClient, private router: Router, private msalService: MsalService) {}
  checkUrlModuloExterno(route: ActivatedRouteSnapshot, accessToken: string): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree{
    for (var urlModulo in modulosActivos)
    {
      if (route.url.toString() == modulosActivos[urlModulo].urlName)
      {
        var selectedModulo = urlModulo;
        return new Promise<boolean>((resolve, reject) =>
        {
          const httpOptions =
            {
              headers: new HttpHeaders().set('Authorization', 'Bearer ' + accessToken)
                .set("Content-type", "application/json")
            }
          let postData = "{\"groupIds\":[\"" + modulosActivos[selectedModulo].id + "\"]}";

          this.http.post("https://graph.microsoft.com/v1.0/me/checkMemberGroups", postData, httpOptions)
            .subscribe(result =>
              {
                var gruposUsuario: ResponseMSGraph = JSON.parse(JSON.stringify(result));
                resolve(gruposUsuario.value.length != 0); // Using resolve here instead of return
              },
              error =>{reject(error);});
        });
      }
    }
    this.router.navigate(['/externo']);
    return false;
  }

  checkUrlModuloInterno(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    for (var urlModulo in modulosHub) {
      if (route.url.toString() == modulosHub[urlModulo].urlName) {
        let selectedModulo = urlModulo;
        return new Promise<boolean>((resolve, reject) => {
          this.msalService.acquireTokenSilent({
            scopes: ['GroupMember.Read.All']
          }).subscribe(resultado => {

            const httpOptions = {
              headers: new HttpHeaders().set('Authorization', 'Bearer ' + resultado.accessToken)
                .set("Content-type", "application/json")
            }
            let postData = "{\"groupIds\":[\"" + modulosHub[selectedModulo].id + "\"]}";
            this.http.post("https://graph.microsoft.com/v1.0/me/checkMemberGroups", postData, httpOptions).subscribe(result => {
              var gruposUsuario: ResponseMSGraph = JSON.parse(JSON.stringify(result));
              resolve(gruposUsuario.value.length != 0); // Using resolve here instead of return
            }, error => {
              reject(error);
            });
          }, error => {
            reject(error);
          });
        });
      }
    }
    return false;
  }
}
